import React from 'react'
import PropTypes from 'prop-types';
import PageContainer from '../../layout/PageContainer';
import CorredorLineaGarantiaClienteDetail from './CorredorLineaGarantiaClienteDetail';


const CorredorLineaGarantiaClienteDetailContainer = ({ match }) => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      {id: 1, name: 'LÍNEAS GARANTÍA CARTERA CLIENTES', url: '/corredor/lineas-garantia/' },
      {id: 2, name: 'DETALLE CLIENTE' },
    ]}
    clientFilter={{
      type: 'corredor',
      ramo: 'garantia',
      showFilter: false,
    }}
  >
    {(corredor) => (
      <CorredorLineaGarantiaClienteDetail match={match} corredor={corredor} />
    )}
  </PageContainer>
);

CorredorLineaGarantiaClienteDetailContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default CorredorLineaGarantiaClienteDetailContainer;
